<tam-dialog tid="mdl_dialog" [opened]="opened" [dialogWidth]="dialogWidth" [titleName]="titleName"
    (keydown.esc)="onCancelBtnClick($event)" class="mdl-dialog-container">
    <ng-template #title>
        <span class="dialog-title">{{titleName}}</span>
        <smart-icon class="dialog-close dark" name="close" (click)="onCancelBtnClick($event)">
        </smart-icon>
    </ng-template>
    <ng-template #body>
        <div class="bodyContainer">
            <div class="field-config-list">
                <div class="field-config-section" *ngFor="let fSection of mdlSections.controls; let i = index"
                    [attr.tid]="getSectionTitle(fSection)">
                    <mdl-dialog-field-section [typeId]="currentTypeId" [sectionFrmGroup]="fSection"
                        (sectionDeleting)="onSectionDeleting($event)">
                    </mdl-dialog-field-section>
                </div>
            </div>
            <div class="bottom-toolbar" loading-spin [isLoading]="isLoading" [loadingSize]="'big'">
                <mdl-dialog-section-add-button [typeId]="currentTypeId"
                    [ngStyle]="{'visibility': isLoading ? 'hidden' : 'visible' }" [fieldsInUse]="fieldsInUse"
                    (fieldSelected)="onFieldSelcted($event)">
                </mdl-dialog-section-add-button>
            </div>
        </div>
    </ng-template>
    <ng-template #footer>
        <button tid="cancel_mdlModification" tam-button tamType="tertiary" tamSize="normal"
            class="dialog-button dialog-cancel footer-research-button"
            (click)="onCancelBtnClick($event)">Cancel</button>
        <button tid="save_mdlModification" tam-button tamType="primary" tamSize="normal"
            class="dialog-button dialog-publish footer-research-button" (click)="onClickSaveTemplate($event)"
            [disabled]="isSaveBtnDisabled||isProgressing" [tamLoading]="isProgressing">Save</button>
    </ng-template>

</tam-dialog>
<ng-template #flyContainer></ng-template>